const navButton = document.querySelector('#mobile-icon')
const menuWrap = document.querySelector('.bm-menu')
const menuOverlay = document.querySelector('.bm-menu__overlay')


function toggle() {
	// toggle nav
	navButton.classList.toggle("open");
	// toggle menu
	menuWrap.classList.toggle("open");
	menuOverlay.classList.toggle("active");
	// add no scroll class to html
	document.documentElement.classList.toggle('overflow-hidden');
}

// add event listeners 

navButton.addEventListener('click', toggle);
menuOverlay.addEventListener('click', toggle);

// detect esc key

window.addEventListener('keydown', event => {
	const escKey = (event.key === 'Escape' || event.keyCode === 27)
	const isOpen = menuWrap.classList.contains('open')
	if (isOpen && escKey) toggle()
})